import { render } from "./NotFoundView.vue?vue&type=template&id=07ebccef&scoped=true&ts=true"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"

import "./NotFoundView.vue?vue&type=style&index=0&id=07ebccef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ebccef"]])

export default __exports__